import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  ItAssets,
  AssignAssetPayload,
  DeAssignAssetPayload,
  ItAssetsResponse,
  AddItAssetsResponse,
  ItAssetsCommonResponse,
  Type,
} from '@core/interface/it_assets/itAssets';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class ItAssetsService {
  constructor(private http: HttpClient) {}

  getItAssets(data?: PagePayload) {
    const filter = { ...data };
    if (typeof filter?.customer_type !== 'undefined') {
      filter.type = filter.customer_type;
    }
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<ItAssetsResponse>(environment.endPoints.itAssetsList, {
      params: httpParams,
    });
  }
  addItAssets(data: ItAssets) {
    return this.http.post<AddItAssetsResponse>(
      environment.endPoints.itAssetsAddEdit,
      data
    );
  }
  deleteItAssets(id: number) {
    return this.http.get<ItAssetsCommonResponse>(
      environment.endPoints.itAssetsDelete(id)
    );
  }

  assignAsset(data: AssignAssetPayload) {
    return this.http.post<ItAssetsCommonResponse>(
      environment.endPoints.assignAsset,
      data
    );
  }

  deAssignAsset(data: DeAssignAssetPayload) {
    return this.http.post<ItAssetsCommonResponse>(
      environment.endPoints.deAssignAsset,
      data
    );
  }
}
